import script from "./goodInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./goodInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./goodInfoAdd.vue?vue&type=style&index=0&id=b20690ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b20690ea"]])

export default __exports__